import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import DocumentModalView from '../components/views/DocumentModalView';
import {FileState} from '../types/types';
import {DocumentModalDispatchProps, DocumentModalStateProps} from '../types/containers';

const mapStateToProps = (state: State, ownProps): DocumentModalStateProps => {
    const data = ownProps.data || null;
    const file: FileState = !!data ? data.file : null;
    return {
        documentUrl: file.url,
        mimeType: file.mimeType
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DocumentModalDispatchProps => {
    return {
    };
};

const DocumentModalContainer = connect(
    mapStateToProps, mapDispatchToProps
)(DocumentModalView);

export default DocumentModalContainer;